define('model/usereact.flag.model',['require','exports','module','fukit'],function(require, exports, module) {

// prettier-ignore
var BaseModel              = require('fukit').BaseModel;

var UseReactFlagsModel = BaseModel.extend({
    radioRequests: {
        'models UseReactFlagsModel': '@constructor',
    },

    useHalSelfLinkAsUrl: false,
    urlRoot: '/api/v2/coi/setting/usereact',

    virtual: {
        isReactUI: {
            deps: ['useReactUI'],
            get: function() {
                return this.get('useReactUI') === true;
            }
        }
    },

  });

module.exports = UseReactFlagsModel;
});

